module.exports = __webpack_public_path__ + "img/banner1-1.9a415242.png";